var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.chargingSiteMathematicalModel && _vm.chargingSiteMathematicalModel.mainFuse)?_c('FuseFields',{attrs:{"value":_vm.chargingSiteMathematicalModel.mainFuse,"editable":false,"highlightedFuseId":_vm.highlightedFuseId}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }